import { TABLA_PEDIDO_CAMIONES_EN_CALADO } from '../../../config/tables'
import { pdfCustomToolbarGenerator } from '../../../models/tools/generarPdf'
import PedidoEgresoCalado from '../../../models/camiones/pedido_egreso_calado'
import { INTERVALO_CORTO } from '../../../config/settings'
import { toast } from 'react-toastify'
import { getColumnasPedidosCamiones, COLUMNS_PEDIDO_CAMIONES_EN_CALADO_TO_PRINT } from './constantesPedidoCamionesEnCalado'

export function actualizarDatosParaMuiTable (rol) {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_PEDIDO_CAMIONES_EN_CALADO
    })
    PedidoEgresoCalado.getPedidosDeBrutoACalado().then(callback)
    function callback (data) {
      const customToolbar = pdfCustomToolbarGenerator(
        'Listado de pedidos',
        data,
        COLUMNS_PEDIDO_CAMIONES_EN_CALADO_TO_PRINT,
        'portrait')
      dispatch({ type: 'RECEIVE_PEDIDOS_DE_BRUTO', data })

      const rolAutorizado = rol && (rol[0] === 'BALANCEROCAMIONES' || rol[0] === 'SUPERVISOR' || rol[0] === 'DESARROLLADOR')
      const columnas = getColumnasPedidosCamiones(rolAutorizado)
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: columnas,
          data: data,
          title: `Listado de pedidos pendientes`,
          isLoading: false,
          fixed2Decimales: false,
          extraOptions: {
            customToolbar,
            print: false,
            search: false,
            viewColumns: false,
            pagination: false,
            download: false,
            tableBodyMaxHeight: '450px'
          }
        },
        id: TABLA_PEDIDO_CAMIONES_EN_CALADO
      })
    }
  }
}

export function deletePedidosDeBruto (fecha, roles) {
  return dispatch => {
    PedidoEgresoCalado.deletePedidosDeBrutoACalado(fecha)
      .then(data => {
        dispatch({ type: 'ELIMINAR_PEDIDO_DE_BRUTO_A_CALADO' })
        if (!data.error) {
          const rol = roles.filter(roles => roles === 'BALANCEROCAMIONES' || roles === 'DESARROLLADOR' || roles === 'SUPERVISOR')
          dispatch(actualizarDatosParaMuiTable(rol))
          toast.success('Pedido eliminado exitosamente.', { autoClose: INTERVALO_CORTO })
        }
      })
  }
}
